import React from 'react'
import "./Loader.css"
import myLogo from "../../Assets/Logo.jpeg"
const Loader = () => {
  return (
    <div className='Loader'>
      <img src={myLogo} alt="" />
    </div>
  )
}

export default Loader
